import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  label?: string;
  options: SelectOption[];
  placeholder?: string;
}
export function Select({
  label,
  options,
  placeholder,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || label?.toLowerCase().replace(/\s/g, '-');
  return <div className="w-full" data-id="element-1094">
      {label && <label htmlFor={selectId} className="block text-xs font-medium text-text-secondary mb-1 uppercase tracking-wide" data-id="element-1095">
          {label}
        </label>}
      <div className="relative" data-id="element-1096">
        <select id={selectId} className={`
            w-full appearance-none
            px-3 py-2
            pr-8
            border border-border rounded-md
            bg-white
            text-text-primary text-sm
            focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary
            transition-colors duration-150
            cursor-pointer
            ${className}
          `} {...props} data-id="element-1097">
          {placeholder && <option value="all" data-id="element-1098">{placeholder}</option>}
          {options.map(option => <option key={option.value} value={option.value} data-id="element-1099">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-text-tertiary pointer-events-none" data-id="element-1100" />
      </div>
    </div>;
}